<template lang="pug">
div(v-if='data.checkbox')
    el-checkbox(
        :checked='localChecked',
        v-model='localChecked',
        @change='onChangeCamada(data, node, $event)'
    )
    el-tooltip(
        :disabled='$t(`mensagens.camadas.${data.nome}`).length < lengthLegenda ? true : false',
        effect='dark',
        :content='$t(`mensagens.camadas.${data.nome}`)',
        placement='top',
        :open-delay='100'
    )
        span(v-if='node.label.length < lengthLegenda', @click='toggleCheck') {{ labelName($t(`mensagens.camadas.${data.nome}`)) }}
        span(v-else, @click='toggleCheck') {{ labelName($t(`mensagens.camadas.${data.nome}`)) }}
div(v-else-if='!data.checkbox && data.icon')
    div(v-if='verificaPastaRevenda(data.chaveTraducao)')
        i(:class='data.icon')
        span {{ $t(`mensagens.camadas.pastas.${data.chaveTraducao}`) }}
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'DrawerMenuCamadasTreeItem',
    props: {
        node: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        menuMaior: {
            type: Boolean,
            required: false,
            default: false
        },
        isChecked: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            localChecked: this.isChecked
        };
    },
    watch: {
        isChecked(newVal) {
            this.localChecked = newVal;
        },
        'node.checked': function (newVal) {
            this.localChecked = newVal;
        }
    },
    computed: {
        lengthLegenda() {
            return this.menuMaior ? 33 : 16;
        },
        checkboxClass() {
            return this.localChecked
                ? 'el-checkbox__input is-checked'
                : 'el-checkbox__input';
        },
        ...mapGetters(['usuarioLogado'])
    },
    methods: {
        toggleCheck() {
            this.localChecked = !this.localChecked;
            this.$emit('update:isChecked', this.localChecked);
            this.onChangeCamada(this.data, this.node);
        },
        onChangeCamada(data, node, event) {
            this.localChecked = event;
            this.$emit('update:isChecked', this.localChecked);
            this.$emit('onChangeCheckboxCamadas', data, node);
        },
        labelName(node) {
            return node.length < this.lengthLegenda
                ? node
                : node.substring(0, this.lengthLegenda) + '...';
        },
        verificaPastaRevenda(nomePasta) {
            const isBe8 = this.usuarioLogado?.nameGroup?.toUpperCase() === 'BE8';
            const isTrade = this.usuarioLogado.isBunge || isBe8;
            const pasta = this.$t(`mensagens.camadas.pastas.${nomePasta}`);
            const pastaCertificacoes = this.$t(`mensagens.camadas.pastas.certificacoes`);

            return pasta === pastaCertificacoes ? isTrade : true;
        }
    }
};
</script>
